module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-restaurant-536b787ad5cda52bdae80c75386a7bbf.jpg";